<template>
    <div>
        <div class="progress" :style="{height:barHeight+'px'}">
            <div class="progress-bar" :class="getColorBar()" role="progressbar" aria-label="Example 20px high" :style="{width: barPorcentaje+'%'}" :aria-valuenow="barPorcentaje" aria-valuemin="0" aria-valuemax="100"></div>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        barPorcentaje:{
            type: Number,
            default: 10
        },
        barHeight:{
            type: Number,
            default: 20
        },
        barBg:{
            type: String,
            default: ''
        }

    },
    data: function(){
        return{

        }
    },
    methods:{
        //falta por definir los colores segun el porcentaje
        getColorBar: function(){
            if(this.barPorcentaje<=10) return 'bg-danger-sh';
            if(this.barPorcentaje<50) return 'bg-warning-sh';
            if(this.barPorcentaje>=50) return 'bg-sucess-sh';



        }
    }

}
</script>